/**
 * Hard-coded configuration for dev, overriding the Cognito config.
 *
 * This can be removed once we cease using the legacy Cognito setup and
 * start using the one created with the Serverless Framework.
 */
const dev = {
  s3: {
    REGION: "eu-central-1",
    BUCKET: "mgp-uploads-dev",
  },
  apiGateway: {
    REGION: "eu-central-1",
    URL: "https://jlobpevgr2.execute-api.eu-central-1.amazonaws.com/dev",
  },
  cognito: {
    REGION: "eu-central-1",
    USER_POOL_ID: "eu-central-1_hoDxXicIi",
    APP_CLIENT_ID: "46r12tcb3fokl0vaa1dpn6iv3l",
    IDENTITY_POOL_ID: "eu-central-1:6c04a316-b28d-4532-967b-2e9acf2c9c68",
  },
  lambdaFn: {
    REGION: "eu-central-1",
    RUN_COMPARISON_FN_URL:
      "https://gq5wkrd2k3m5n3t3qg6kyckhpq0adptn.lambda-url.eu-central-1.on.aws/",
  },
};

const defaultConfig = {
  s3: {
    REGION: process.env.REACT_APP_REGION,
    BUCKET: process.env.REACT_APP_UPLOADS_BUCKET,
  },
  apiGateway: {
    REGION: process.env.REACT_APP_REGION,
    URL: process.env.REACT_APP_SERVICE_ENDPOINT,
  },
  cognito: {
    REGION: process.env.REACT_APP_REGION,
    USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
  },
  lambdaFn: {
    REGION: process.env.REACT_APP_REGION,
    RUN_COMPARISON_FN_URL: process.env.REACT_APP_RUN_COMPARISON_FN_URL,
  },
};

const config =
  process.env.REACT_APP_STAGE === "dev" ? dev
  : defaultConfig;

export default config;
